jQuery(document).ready(function($){

  $.ajaxSetup({ cache: false });


  var header          = jQuery('#header'),
  panier          = $('.miniHeader .inCartItems'),
  inputHidden     = jQuery('.inputHidden'),
  // Content Elments to update:
  validBlock      = jQuery('.valid'),
  validPrice      = validBlock.find('.table .prx'),
  cart            = jQuery.getJSON('/cart.js', function(data){
    return data;
  }),
  // Filament elements 
  fil             = jQuery('.more .fils').find('.selector'),
  filColor        = jQuery('.more .fils .filbl'),
  filColorLix     = jQuery('.more .fils .flmt'),
  filColorLixTwo  = jQuery('.more .fils .flmt.scnd'),
  filColorsArray  = ['blk', 'wht', 'gry', 'red', 'org', 'ylw', 'grn', 'ble', 'vlt', 'blkT', 'whtT', '', '', '', '', '', '', '', '', ''],
  filSubmit       = fil.find('a.submit'),
  filSelCol       = fil.find('.colors a'),
  filColors       = fil.find('.colors .clr'),
  absPlaBtn       = fil.find('.btn-type'),
  arrowLinks      = fil.find('a.arrow'),
  clrs            = fil.find('.colors'),
  hoverColors     = fil.find('.clr'),
  clrsElms        = parseInt(hoverColors.length / 7),
  clrsElmWidth    = parseInt(hoverColors.outerWidth()) + 10,
  // clrsElmWidth    = parseInt(hoverColors.innerWidth()) + 6 + 4 + 4,
  arwCntr         = 0,
  filId           = 0,
  filQnt          = 0,
  filUpdate       = {updates:{}},
  //
  free_shipping   = $(".valid .shipping-price");

var money_format = "€{{amount}}";
      Shopify.money_format = money_format;

  // Filament Init
  jQuery.getJSON('/cart.js', function(e){
    for (var item in e.items){
      filColors.each(function(i){
        if ($(this).data('id') == e.items[item].id) {
          $(this).find('span.'+$(this).data('id')).text(e.items[item].quantity);
          filBtnUpd();
        }
      });
    }
    filInit();
  });

// Cart JS Add Quantity, Update Quantity
  var quantityButtons = $('.clrs .btn-gray');
  var cartUpdate      = $('.cartUpdate');
  quantityButtons.each(function(){
    $(this).on('click', function(e){
      e.preventDefault();
    // var quantity = $(this).closest('.qnt').value();
    var qntElem   = $(this).parent().find('.qnt');
    var qntElemId   = $(this).parent().find('.qnt').attr('id');
    var productQuantity  = parseInt(qntElem.text());
    // console.log($(this).parent().find('.qnt'));
    if($(this).hasClass("ajou") && productQuantity >= 0){
      productQuantity++;
      qntElem.text(productQuantity);
      if (productQuantity == 1) {
        addToCart(qntElemId, $(this), productQuantity);
      } else {
        updateTheCart(qntElemId,$(this),productQuantity);
      }
    } else if ($(this).hasClass("supp") && productQuantity >= 1) {
      productQuantity--;
      qntElem.text(productQuantity);
      updateTheCart(qntElemId,$(this),productQuantity);
    }
    if (cartUpdate.hasClass('hidden')){
      cartUpdate.removeClass('hidden');
    }
  });
  });

  function addToCart(id, elem, qnt) {
    jQuery.post('/cart/add.js', {
      quantity: qnt,
      id: id
    },
    null,
    "json").done(function(data){
      updateContent();
      updateBtn(elem);
      validShow();
    }).fail(function(jqxhr, textStatus, error){
      updateBtnFail(elem);
      console.log('Error: ' + textStatus + " // " + error + " // PLEASE CONTACT LIXPEN LTD ABOUT THE ISSUE");
    });
  }

  function updateTheCart(id, elem, qnt) {
    jQuery.post('/cart/change.js', {
          // updates: {
            quantity: qnt,
            id: id
          // }
        },
        null,
        "json").done(function(data){
          updateContent();
          updateBtn(elem);
          validShow();
        }).fail(function(jqxhr, textStatus, error){
          updateBtnFail(elem);
          console.log('Error: ' + textStatus + " // " + error + " // PLEASE CONTACT LIXPEN LTD ABOUT THE ISSUE");
        });
      }



  // Revision
  function updateElem(e, elem) {
    elem.html(e);
  }
  // OK
  function updateBtn(elem){
    elem.addClass("success");
    setTimeout(function(){
      elem.removeClass("success")
    }, 1000);
  }
  // OK
  function updateBtnFail(elem){
    elem.addClass("fail");
    setTimeout(function(){
      elem.removeClass("fail")
    }, 1000);
  }



// Product Submit

jQuery('.clrs .btnclrs').find('a').on('click', function(e){
  inputHidden = inputHidden.attr('value', jQuery(this).attr('for'));
});
jQuery('a#submit').stop().on('click', function(e){
  e.preventDefault();
  addToCart(inputHidden.attr('value'), $(this), 1);
});
// Filament Init Quantity visibility
function filInit(){
  filColors.each(function(i){
    var thisSpan      = $(this).find('span#qnt');
    var spanNumber    = parseInt(thisSpan.text());
      // console.log('SpanNum: ' + spanNumber);
      if(spanNumber>0){
        thisSpan.css('visibility', 'visible');
      }
    });
}
function filBtnUpd(){
  filSubmit.text("Update");
}

// Abs PLA Buttons 
  absPlaBtn.each(function(i){
      console.log('find: ' + i);
    $(this).on('click', function(){
      console.log($(this).attr('for'));
      if($(this).attr('for') == "pla"){
        filColors.each(function(){
          if ($(this).hasClass("abs")){
            $(this).addClass('hidden');
            console.log("ABS hide");
          } else {
            $(this).removeClass('hidden');
          }
        });

      } else if($(this).attr('for') == "abs") {

        filColors.each(function(){
          if ($(this).hasClass("pla")){
            $(this).addClass('hidden');
            console.log("PLA hide");
          } else {
            $(this).removeClass('hidden');
          }
        });
      }
    });
  });


// Filament Color Hover :
  filColors.each(function(){
    $(this).on('mouseenter', function(){
      console.log('MouseEntered')
      var myColor = $(this).attr('id');
      jQuery.each(filColorsArray, function(i, val){
        filColor.removeClass(val);
        filColorLix.each(function(){
          $(this).removeClass(val);
        });
      });
      filColor.addClass(myColor);
        filColorLix.each(function(){
          $(this).addClass(myColor);
        });
    });
  });


  // Filament Colors scroll:
  arrowLinks.on('click', function(e){
    e.preventDefault();
    var thisBtn           = $(this).hasClass('icon-arleft'),
        colorPos          = parseInt(clrs.css('left')),
        steps             = 1,
        move;                 // on click in left/right arrow it moves 3 color's elements right/left
        arwCntr           = thisBtn ? arwCntr + 1 : arwCntr - 1;
    if (thisBtn && arwCntr > 0) {
      arwCntr = 0;
    } else if (arwCntr < -clrsElms) {
      arwCntr = arwCntr+1;
    }
    move                  = 30 + (clrsElmWidth*steps)*arwCntr;
    // console.log('lftBtn:' + thisBtn + ' // colorPos: ' + colorPos + ' // arwCntr: ' + arwCntr + ' // move : ' + move + ' // clrsElms: ' + clrsElms); // true = left button; false = right button
    clrs.css('left', move);
  });

// Filament Select

filSelCol.each(function(){

  $(this).on('click', function(e){
    e.preventDefault();
    filQntElem  = $(this).parent().find('#qnt');
    filSpan     = $(this).parent().find('span');
    filQnt      = parseInt(filQntElem.text());
    if ($(this).hasClass('icon-ard') && filQnt > 0){
      filQnt--;
    } else if ($(this).hasClass('icon-arup')) {
      filQnt++;
    }
    filSpan.css('visibility', 'visible');
    filQntElem.text(filQnt);
    filId = $(this).data('id');
    // console.log('id: ' + filId + ' // filQnt: ' + filQnt);
    filUpdate.updates[filId] = filQnt;
    // console.log(filUpdate);
  });
});

// Filament Submit
filSubmit.stop().on('click', function(e){
  e.preventDefault();
// console.log(filUpdate);
// console.log(filColors.variants.id);
// addToCart(inputHidden.attr('value'), $(this), 1);


jQuery.post('/cart/update.js', filUpdate,
  null,
  "json").done(function(data){
    updateContent();
    filBtnUpd();
    validShow();
  }).fail(function(jqxhr, textStatus, error){
    console.log('Error: ' + textStatus + " // " + error + " // PLEASE CONTACT WITH WEB ADMIN OF LIXPEN LTD");
  });
});
// -----------------------------
function selection(id){
  var selectedId = id
}
function validShow(){
  if(!(validBlock.hasClass('show'))){
    validBlock.addClass('show')
  }
}



  function updateContent(){
    jQuery.getJSON('/cart.js', function(e){
      cart = e;
      // Currency.convertAll(defaultCurrency, Currency.currentCurrency);
      var finalPrice = Shopify.formatMoney(e.total_price);
      console.log(e);
      console.log('Currency : ' + Shopify.money_format + '  : ' + Shopify.formatMoney(e.total_price, ''));

      console.log(finalPrice);
      updateCart(e);
      updateElem(finalPrice, validPrice);
      freeShipping();
    });
  }

  // Free Shipping updater
  function freeShipping(){
    jQuery.getJSON('/cart.js', function(e){
      cart = e;
      var freeShippingGoal = 12500 - e.total_price;
      freeShippingGoal = Shopify.formatMoney(freeShippingGoal);
      // Currency.convertAll(defaultCurrency, Currency.currentCurrency);
      var finalPrice = Shopify.formatMoney(e.total_price);
      if (e.total_price >= '12500') {
        free_shipping.html("You've qualified for Free Shipping.");
      } else {
        free_shipping.html("You’re just " + freeShippingGoal + " away from FREE shipping.");
      }

      // updateCart(e);
      // updateElem(finalPrice, validPrice);
    });
  }
  freeShipping();
  // Update miniHeader Cart
  function updateCart(e) {
    panier.text(e.item_count);
  }
});